// This is an auto-generated file and cannot be edited
export const environment = {
    NODE_ENV: 'prod',
    USER_POOL_CLIENT_ID: 'f3lid46ek35lc4k1pic05f8q4',
    USER_POOL_ID: 'us-east-1_tlHsZcIFy',
    IDENTITY_POOL_ID: 'us-east-1:af74c2e5-59a5-4719-9895-2cf5ba359dd5',
    OAUTH_DOMAIN: 'watter-prod.auth.us-east-1.amazoncognito.com',
    API_END_POINT: 'https://api.wattertechnologies.com/graphql',
    S3_BUCKET: '050752630324-account-profile-prod',
    APP_REGION: 'us-east-1',
    APP_VERSION: '1.0.7',
};
